import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


// Fix for mobile viewport height (for browsers that don't support dvh)
// This calculates the actual viewport height and stores it in a CSS custom property
const setViewportHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

// Set on load
setViewportHeight();

// Update on resize and orientation change
window.addEventListener('resize', setViewportHeight);
window.addEventListener('orientationchange', setViewportHeight);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

